import React, { useState } from "react";
import styles from "./Product.module.sass";

import Row from "./Row";

const Table = ({ items, setSelectedProducts, removeSelectedProduct }) => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Product</div>
          <div className={styles.col}>Price</div>
          <div className={styles.col}>Quantity</div>
          {/* <div className={styles.col}>{title}</div> */}
        </div>
        {items.map((x, index) => (
          <Row
            item={x}
            key={index}
            index={index}
            value={selectedFilters.includes(x.id)}
            onChange={() => handleChange(x.id)}
            removeSelectedProduct={removeSelectedProduct}
            setSelectedProducts={setSelectedProducts}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
